module.exports = __webpack_public_path__ + "img/avatar-s-20.e8861d8c.jpg";